<template>
  <vueMain :title="$t('buttons.users')">
    <div class="card">
      <div class="container-fluid">
        <div class="row">
          <nav class="col-lg-2 pl-0 pr-0 sidebar hover-bg">
            <b-nav vertical class="nav-pills">
              <b-nav-item to="Users" active><i class="fa fa-users"></i>{{ $t("buttons.users") }}</b-nav-item>
              <b-nav-item to="Settings"><i class="fa fa-cog"></i> {{ $t("buttons.settings") }}</b-nav-item>
              <b-nav-item @click="logout"><i class="fa fa-sign-out"></i> {{ $t("buttons.logout") }}</b-nav-item>
            </b-nav>
          </nav>
          <div class="col-lg-10 pr-0">
            <div class="card-header text-center border-bottom-0">
                <h3>{{$t('users.title')}}</h3>
                <b-btn data-trackname="AddUser" v-b-modal.AddUser variant="primary" @click="clearUserTable" class="card-header-button">
                 {{$t('users.addUser')}} <i class="fa fa-plus"></i>
                </b-btn>
            </div>
            <div class="card-body">
              <v-client-table
                  :columns="columns"
                  :data="users"
                  :options="options"
                  >
              </v-client-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <user-form :userTable="user2Edit" @refreshUsers="getUsers" @clearUser="clearUserTable"></user-form>
  </vueMain>
</template>

<script>
import UserForm from '@/components/Pages/Users/UserForm';
import vueMain from '@/components/Layout/Main.vue';

import Vue from 'vue';
import { mapGetters } from 'vuex';

// function capitalize (string) {
//   string = string.charAt(0).toUpperCase() + string.slice(1)
//   return string.replace('_', ' ')
// }

Vue.component('boolTemplate_is_superuser', {
  props: ['data', 'index', 'column'],
  template: `<i :class="checkClass" :style="style"></i>`,
  computed: {
    checkClass () {
      return this.data.is_superuser ? 'fa fa-check' : 'fa fa-times';
    },
    style () {
      return this.data.is_superuser ? 'color:green' : 'color:red';
    }
  }
});

Vue.component('boolTemplate_is_staff', {
  props: ['data', 'index', 'column'],
  template: `<i :class="checkClass" :style="style"></i>`,
  computed: {
    checkClass () {
      return this.data.is_staff ? 'fa fa-check' : 'fa fa-times';
    },
    style () {
      return this.data.is_staff ? 'color:green' : 'color:red';
    }
  }
});

Vue.component('boolTemplate_is_active', {
  props: ['data', 'index', 'column'],
  template: `<i :class="checkClass" :style="style"></i>`,
  computed: {
    checkClass () {
      return this.data.is_active ? 'fa fa-check' : 'fa fa-times';
    },
    style () {
      return this.data.is_active ? 'color:green' : 'color:red';
    }
  }
});

Vue.component('groupsTemplate', {
  props: ['data', 'index', 'column'],
  template: `<span v-html="groupsList"></span>`,
  computed: {
    groupsList () {
      let out = '<ul class="pl-1">';
      for (let i in this.data.groups) {
        out += '<li>' + this.data.groups[i].name + '</li>';
      }
      out += '</ul>';
      return out;
    }
  }
});

Vue.component('editTemplate', {
  name: 'edit',
  props: ['data', 'index', 'column'],
  template: `<span v-b-modal.AddUser @click="sendUser" class="fa-stack"> <i data-toggle="row" class="fa fa-circle-thin fa-stack-2x"></i> <i class="fa fa-pencil fa-stack-1x"></i> </span>`,
  methods: {
    sendUser () {
      let url = 'users/' + this.data.id + '/';
      this.$http.get(url).then(response => {
        this.$store.commit('SET_USER', response.body);
      });
    }
  }
});

export default {
  name: 'Users',
  components: {
    'user-form': UserForm,
    vueMain
  },
  computed: {
    ...mapGetters(['user2Edit'])
  },
  methods: {
    getGroups: function () {
      this.$http.get('groups/').then(response => {
        this.groupOptions = response.body;
        this.groupSelected = [this.groupOptions[0]];
      });
    },
    getUsers: function () {
      this.$http.get('users/').then(response => {
        this.users = response.body;
      });
    },
    clearUserTable: function () {
      this.$store.commit('SET_USER', {});
    },
    logout: function () {
      document.cookie =
      'kernel_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
      document.location.replace('/');
    }
  },
  mounted () {
    this.getUsers();
    this.getGroups();
  },
  data () {
    return {
      columns: [
        'id',
        'email',
        'first_name',
        'last_name',
        'groups',
        'is_active',
        'is_staff',
        'is_superuser',
        'last_login',
        'date_joined',
        ' '
      ],
      trigger: 0,
      errorMsgs: '',
      content: '',
      users: [],
      user: {},
      options: {
        skin: 'table-hover',
        templates: {
          is_staff: 'boolTemplate_is_staff',
          is_active: 'boolTemplate_is_active',
          is_superuser: 'boolTemplate_is_superuser',
          groups: 'groupsTemplate',
          ' ': 'editTemplate'
        }
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Users/Index.vue